import React from 'react';
import './BookAnchorCard.css';

export default function BookAnchorCard({ book, onRemove }) {
  return (
    <div className="book-anchor-card">
      <div className="book-anchor-card__cover">
        {book.coverUrl
          ? <img src={book.coverUrl} alt="" />
          : <span className="book-anchor-card__cover-placeholder"><i className="ph ph-book" /></span>
        }
      </div>
      <div className="book-anchor-card__info">
        <p className="book-anchor-card__title">{book.title}</p>
        {book.author && <p className="book-anchor-card__author">{book.author}</p>}
        {book.year && <p className="book-anchor-card__year">{book.year}</p>}
      </div>
      <button className="book-anchor-card__remove" onClick={onRemove} aria-label={`Remove ${book.title}`}>
        <i className="ph ph-x" />
      </button>
    </div>
  );
}
